import TimeZone from './TimeZone.component';

export default TimeZone;
